module.exports = __webpack_public_path__ + "static/img/szbanner.cf048f61.png";